export const enum UserRoles {
  Administrator = 'Administrator',
  SuperAdmin = 'Super Admin',
}
